import { SubAreaContent } from "../contentManager/SubAreaContent";
import "./GovernanceView.scss";

export const GovernanceView = () => {
    return <div className="governance-container">
        <h2>Governance</h2>
        <SubAreaContent isProjectSpecific={true} area="governance" />
    </div>;
};